import { RecipeVariantProps, sva } from "styled-system/css";

export const staffCard = sva({
  slots: ["root", "avatar", "text", "textRole", "textStatus", "btnEdit"],
  base: {
    root: {
      bgColor: "white",
      border: "none",
      boxShadow: "50",
      "&[data-hovered='true']": {
        boxShadow: "200",
      },
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
    },
    avatar: {
      flexShrink: 0,
      width: "48px",
      height: "48px",
      borderRadius: "full",
      transitionProperty: "opacity",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
    },
    text: {
      color: "text.mid",
      "&[data-hovered='true']": {
        color: "text.dark",
      },
      transitionProperty: "color",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
    },
    textRole: {
      position: "absolute",
      top: "0",
      left: "0",
      opacity: 1,
      transitionProperty: "opacity",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
    },
    textStatus: {
      position: "absolute",
      top: "0",
      left: "0",
      opacity: 0,
      transitionProperty: "opacity",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
    },
    btnEdit: {
      borderRadius: "full",
      p: "0",
      color: "icon.light",
      _hover: {
        color: "icon.mid",
      },
      _focusVisible: {
        color: "icon.mid",
      },
      "&[data-hovered='true']": {
        color: "icon.mid",
        _hover: {
          color: "icon.dark",
        },
        _focusVisible: {
          color: "icon.dark",
        },
      },
      transitionProperty: "color",
      transitionDuration: "normal",
      transitionTimingFunction: "default",
    },
  },
  variants: {
    visual: {
      normal: {
        root: {},
        avatar: {},
        text: {},
        textRole: {
          "&[data-hovered='true']": {
            opacity: 0,
          },
        },
        textStatus: {
          "&[data-hovered='true']": {
            opacity: 1,
          },
        },
        btnEdit: {},
      },
      dimmed: {
        root: {
          bgColor: "bg.wa.lightest",
        },
        avatar: {
          opacity: 0.5,
          filter: "grayscale(100%)",
          "&[data-hovered='true']": {
            opacity: 0.75,
          },
        },
        text: {},
        textRole: {
          "&[data-hovered='true']": {
            opacity: 0,
          },
        },
        textStatus: {
          "&[data-hovered='true']": {
            opacity: 1,
          },
        },
        btnEdit: {},
      },
    },
  },
  defaultVariants: {
    visual: "normal",
  },
});

export type StaffCardVariants = RecipeVariantProps<typeof staffCard>;
